module.exports = require('./helpers/bundle-url').getBundleURL('8De2n') + "logo-dark.eefe0b7f.svg";